import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AngularLibraryBootstrapModule } from '../../angular-library-bootstrap.module';
import { TreeviewI18n } from 'ngx-treeview';
import { AngularTreeviewComponent } from './treeview.component';
import { TreeviewI18nCustom } from './treeviewI18n-custom';

@NgModule({
    imports: [CommonModule, FormsModule, AngularLibraryBootstrapModule],
    declarations: [AngularTreeviewComponent],
    exports: [AngularTreeviewComponent],
    providers: [{ provide: TreeviewI18n, useClass: TreeviewI18nCustom }]
})
export class AngularTreeviewModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/treeview/treeview.module.ts